/** US phone fields: max digits accepted in signup / profile inputs. */
export const PHONE_INPUT_MAX_DIGITS = 10;

/**
 * Extracts digits only, capped at {@link PHONE_INPUT_MAX_DIGITS}.
 * @param {unknown} value
 * @returns {string}
 */
export function normalizePhoneInputDigits(value) {
  return String(value ?? '')
    .replace(/\D/g, '')
    .slice(0, PHONE_INPUT_MAX_DIGITS);
}

/**
 * Digits-only phone for JSON API bodies (no dashes or other formatting).
 * @param {unknown} value
 * @returns {string}
 */
export function phoneDigitsForApi(value) {
  return normalizePhoneInputDigits(value);
}

/**
 * Masks user input as XXX-XXX-XXXX while typing. Ignores non-digits; caps at 10 digits.
 * Use for controlled `value` on phone fields (digits-only in practice; dashes are formatting).
 * @param {unknown} rawValue
 * @returns {string}
 */
export function formatPhoneInputMask(rawValue) {
  const digits = normalizePhoneInputDigits(rawValue);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
}
